import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
    PreferredContactMethodsCode,
    ContactTitles,
    ContactGroups,
    MappedContactTitles,
    MappedContactMethod,
    MappedContactGroups
} from "../interfaces/ce-helpers.interface";
import { RequestUtilsService } from "./requestUtils";
import { GetHttpHeadersSimple } from "./serviceUtils";

@Injectable({
    providedIn: "root"
})
export class CEHelpersService {
    constructor(private requestUtils: RequestUtilsService) {}

    getPreferredContactMethods(): Observable<PreferredContactMethodsCode> {
        const url = `EntityDefinitions(LogicalName='contact')/Attributes(LogicalName='preferredcontactmethodcode')/Microsoft.Dynamics.CRM.PicklistAttributeMetadata?$select=LogicalName&$expand=OptionSet($select=Options)`;
        return this.requestUtils.createGetRequest<PreferredContactMethodsCode>(url, (response) => response, GetHttpHeadersSimple);
    }

    getContactTitles(): Observable<ContactTitles> {
        const url = `EntityDefinitions(LogicalName='contact')/Attributes(LogicalName='svk_title')/Microsoft.Dynamics.CRM.PicklistAttributeMetadata?$select=LogicalName&$expand=OptionSet($select=Options)`;
        return this.requestUtils.createGetRequest<ContactTitles>(url, (response) => response, GetHttpHeadersSimple);
    }

    getContactGroups(): Observable<ContactGroups> {
        const url = `EntityDefinitions(LogicalName='contact')/Attributes(LogicalName='svk_contactgroup')/Microsoft.Dynamics.CRM.MultiSelectPicklistAttributeMetadata?$select=LogicalName&$expand=OptionSet($select=Options)`;
        return this.requestUtils.createGetRequest<ContactGroups>(url, (response) => response, GetHttpHeadersSimple);
    }

    // mappers
    public mapContactMethods(data: PreferredContactMethodsCode): MappedContactMethod[] {
        return data.OptionSet.Options.map((option) => ({
            value: option.Value,
            isHidden: option.IsHidden,
            hasChanged: option.HasChanged,
            label: option.Label.LocalizedLabels
        }));
    }

    public mapContactTitles(data: ContactTitles): MappedContactTitles[] {
        return data.OptionSet.Options.map((option) => ({
            value: option.Value,
            isHidden: option.IsHidden,
            label: option.Label.LocalizedLabels
        }));
    }

    public mapContactGroups(data: ContactGroups): MappedContactGroups[] {
        return data.OptionSet.Options.map((option) => ({
            value: option.Value,
            isHidden: option.IsHidden,
            label: option.Label.LocalizedLabels
        }));
    }
}
